import { useEffect } from 'react';
import { auth } from '@/auth';

const Login = () => {
  useEffect(() => {
    auth.login();
  }, [auth]);

  return null;
};

export default Login;
